import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawNestedIcon from "./RawNestedIcon.svg.jsx";

const NestedIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawNestedIcon} {...props} />;
});

export default NestedIcon;
